/* eslint-disable */
import {Box, styled} from '@mui/material'
import React from 'react'

export const Bold = styled(Box)<{small?: boolean}>`
  font-weight: ${({theme}) => 'bold'};
  font-size: ${({small}) => (small ? '14px' : null)};
`
